import { useState } from "react";

export function useForceUpdate() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dummy, setDummy] = useState(0);

  return () => setDummy((dummy) => dummy + 1);
}
